import { render } from "./NotificationFolderEditItemPane.vue?vue&type=template&id=802655ee&scoped=true&ts=true"
import script from "./NotificationFolderEditItemPane.vue?vue&type=script&lang=ts"
export * from "./NotificationFolderEditItemPane.vue?vue&type=script&lang=ts"

import "./NotificationFolderEditItemPane.vue?vue&type=style&index=0&id=802655ee&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-802655ee"]])

export default __exports__